import {
  CancelApplicationDto,
  ChangeApplicationProductDto,
} from "../../api/commercial/generated-types";

import { Product } from "./product";
import { ApplicationFlowSteps } from "../../route/application/authenticated/application-flow/types";
import { CancelReasonModel } from "../../pages/shared/components/cancel-dialog/types";
import { getCancelReasonOptionsData } from "../../pages/shared/components/cancel-dialog/cancel-reason";

const mapChangeApplicationProductRequest = (
  newProduct: Product,
  lastApplicationFlowStep: ApplicationFlowSteps,
): ChangeApplicationProductDto => {
  return {
    productRef: newProduct.productRef,
    lastApplicationFlowStep:
      lastApplicationFlowStep as CancelApplicationDto["lastApplicationFlowStep"],
  };
};

const mapCancelApplicationRequest = (
  lastApplicationFlowStep: ApplicationFlowSteps,
  cancelReasonModel: CancelReasonModel,
  getMessage: (key: string, ...params: unknown[]) => string,
  productRef: string,
): CancelApplicationDto => {
  const { cancelReasonOptionOtherValue } =
    getCancelReasonOptionsData(getMessage);

  return {
    lastApplicationFlowStep:
      lastApplicationFlowStep as CancelApplicationDto["lastApplicationFlowStep"],
    cancellationReason:
      cancelReasonModel?.cancelReasonOption === cancelReasonOptionOtherValue &&
      cancelReasonModel.otherReason
        ? cancelReasonModel.otherReason
        : cancelReasonModel.cancelReasonOption,
    productRef: productRef,
  };
};

const ProductMapper = {
  mapCancelApplicationRequest,
  mapChangeApplicationProductRequest,
};
export default ProductMapper;
